import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceJoinRequestItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceJoinRequestItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceJoinRequestItem","document":WorkspaceJoinRequestItemDocument}} as const;
export type WorkspaceJoinRequestItemQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type WorkspaceJoinRequestItemQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'avatarUrl' | 'fullName' | 'idEnterprise' | 'username'>
    & { nonPublic?: Types.Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Types.Member_NonPublic, 'avatarUrl' | 'fullName'>
    )> }
  )> }
);

/**
 * __useWorkspaceJoinRequestItemQuery__
 *
 * To run a query within a React component, call `useWorkspaceJoinRequestItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceJoinRequestItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceJoinRequestItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceJoinRequestItemQuery(
  baseOptions: TrelloQueryHookOptions<
    WorkspaceJoinRequestItemQuery,
    WorkspaceJoinRequestItemQueryVariables
  > &
    (
      | { variables: WorkspaceJoinRequestItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspaceJoinRequestItemDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspaceJoinRequestItemQuery,
    WorkspaceJoinRequestItemQueryVariables
  >(WorkspaceJoinRequestItemDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspaceJoinRequestItemLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspaceJoinRequestItemQuery,
    WorkspaceJoinRequestItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceJoinRequestItemQuery,
    WorkspaceJoinRequestItemQueryVariables
  >(WorkspaceJoinRequestItemDocument, options);
}
export function useWorkspaceJoinRequestItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        WorkspaceJoinRequestItemQuery,
        WorkspaceJoinRequestItemQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkspaceJoinRequestItemQuery,
    WorkspaceJoinRequestItemQueryVariables
  >(WorkspaceJoinRequestItemDocument, options);
}
export type WorkspaceJoinRequestItemQueryHookResult = ReturnType<
  typeof useWorkspaceJoinRequestItemQuery
>;
export type WorkspaceJoinRequestItemLazyQueryHookResult = ReturnType<
  typeof useWorkspaceJoinRequestItemLazyQuery
>;
export type WorkspaceJoinRequestItemSuspenseQueryHookResult = ReturnType<
  typeof useWorkspaceJoinRequestItemSuspenseQuery
>;
export type WorkspaceJoinRequestItemQueryResult = Apollo.QueryResult<
  WorkspaceJoinRequestItemQuery,
  WorkspaceJoinRequestItemQueryVariables
>;
